import {BrowserRouter as Router, Route, Link, Switch, Redirect} from "react-router-dom";
import Account from "./components/Account";
import Home from "./components/Home";
import Login from "./components/Login";
import Navbar from "./components/Navbar";
import Register from "./components/Register";
import {onAuthStateChanged} from "firebase/auth";
import {auth} from "./firebase";
import {useState} from "react";
import ProductCategory from "./components/ProductCategory";
import ProductInfo from "./components/ProductInfo";
import Cart from "./components/Cart";
import Orders from "./components/Orders";
import Wishlist from "./components/Wishlist";
import Shop from "./components/Shop";
import Info from "./components/Info";
import Admin from "./components/Admin";
import Page404 from "./components/Page404";


function App() {

  const [user, setUser] = useState();
  const [userProv, setUserProv] = useState();
  const [isUser, setIsUser] = useState(false);

  onAuthStateChanged(auth, (user) => {
    if(user){
      setUserProv(user.providerData[0].providerId)
      setUser(user);
      setIsUser(true);
    }else{
      setIsUser(false)
    }
  })
  return (
    <Router>
      <div className="App">
        <Navbar isUser = {isUser} user = {user}/>

        <Switch>
          <Route exact path= "/">
            <Home isUser = {isUser} user = {user}/>
          </Route>
          <Route path= "/register">
            {!isUser ? <Register/> : <Redirect to = "/"/> }
          </Route>
          <Route path= "/login">
            {!isUser ? <Login/> : <Redirect to = "/"/> }
          </Route>
          {user && user.email == "admin@gmail.com" && <Route path= "/admin/add-product">
            <Admin isUser = {isUser} user = {user}/>
          </Route>}
          <Route path= "/info">
            <Info user = {user} isUser = {isUser} userProv = {userProv}/>
          </Route>
          <Route path= "/shop">
            <Shop isUser = {isUser} />
          </Route>
          <Route path= "/cart">
            {isUser ? <Cart user = {user} isUser = {isUser}/> : <Redirect to= "/login"/>}
          </Route>
          <Route path= "/orders">
            {isUser ? <Orders user = {user} isUser = {isUser}/> : <Redirect to = "/login"/>}
          </Route>
          <Route path= "/wishlist">
            {isUser ? <Wishlist user = {user} isUser = {isUser}/> : <Redirect to = "/login"/>}
          </Route>
          <Route path= "/account">
            {isUser ? <Account isUser = {isUser} user = {user} userProv = {userProv}/> : <Redirect to= "/login"/>}
          </Route>
          <Route exact path = "/category/:id">
            {isUser ? <ProductCategory user = {user} isUser = {isUser}/> : <Redirect to = "/login"/>}
          </Route>
          <Route path = "/category/:first/:second">
            {isUser ? <ProductInfo user = {user} isUser = {isUser}/> : <Redirect to = "/login"/>}
          </Route>

          <Route path= "/*">
            <Page404/>
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
